import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../../../global/default-button/default-button';
import { Popover } from '../../../../../../../global/popover/popover';
import { ADD_MODULE_BUTTON_TEXT } from '../../../../../../event-hubs.text';
import { HubModuleType } from '../../../../../../../../api/event-hubs.dao';
import { useAnchoredCoords } from './use-anchored-coords';
import { MODULE_TYPE_OPTIONS, POPOVER_GAP, POPOVER_WIDTH } from './module-type-picker.config';
import './module-type-picker.scss';

type ModuleTypePickerProps = {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onSelect: (type: HubModuleType) => void;
    disabled?: boolean;
    className?: string;
};

export const ModuleTypePicker: React.FC<ModuleTypePickerProps> = observer(props => {
    const { isOpen, onOpen, onClose, onSelect, disabled, className } = props;
    const { buttonRef, coords, isPopoverVisible } = useAnchoredCoords({
        isOpen: isOpen,
        onClose: onClose,
        popoverWidth: POPOVER_WIDTH,
        gap: POPOVER_GAP,
    });

    const handleButtonClick = isOpen ? onClose : onOpen;

    return (
        <div className={classnames('module-type-picker', className, { 'module-type-picker--open': isOpen })}>
            <DefaultButton
                ref={buttonRef}
                modifier='link'
                className='module-type-picker__trigger'
                text={<FormattedMessage {...ADD_MODULE_BUTTON_TEXT} />}
                onClick={handleButtonClick}
                disabled={disabled}
            />
            <Popover
                buttonRef={buttonRef}
                isOpen={isPopoverVisible}
                onClickOutside={onClose}
                customTop={coords?.top}
                customLeft={coords?.left}
                customWidth={POPOVER_WIDTH}
            >
                <ul className='module-type-picker__options'>
                    {MODULE_TYPE_OPTIONS.map(option => (
                        <li
                            key={option.type}
                            className='module-type-picker__option'
                            onClick={() => onSelect(option.type)}
                        >
                            <span className='module-type-picker__option-name'>
                                <FormattedMessage {...option.nameText} />
                            </span>
                            <span className='module-type-picker__option-description'>
                                <FormattedMessage {...option.descriptionText} />
                            </span>
                        </li>
                    ))}
                </ul>
            </Popover>
        </div>
    );
});
